export default {
  ADD_CATEGORY (state, category) {
    state.categories.unshift(category)
  },
  SET_CATEGORY (state, categories) {
    state.categories = categories
  },
  UPDATE_CATEGORY (state, category) {
    const categoryIndex = state.categories.findIndex((p) => p._id === category._id)
    Object.assign(state.categories[categoryIndex], category)
  },
  REMOVE_CATEGORY (state, categoryId) {
    const categoryIndex = state.categories.findIndex((p) => p._id === categoryId)
    state.categories.splice(categoryIndex, 1)
  }
}
  